import { useState, useEffect } from 'react';
import { usePrevious } from '../../../shared/src/hooks/use-previous.hook';

export const useWinnersCalculateHook = ({
    gamesToRender,
    maxAmountOfWinnersThumbnails,
    containerGridRef,
}) => {
    const [countColumns, setCountColumns] = useState(0);
    const [amountOfWinnersThumbnails, setAmountOfWinnersThumbnails] = useState(maxAmountOfWinnersThumbnails);
    
    const isValueChanged = (value) => usePrevious(value) !== value;
    const countColumnsChanged = isValueChanged(countColumns);
    const gamesToRenderChanged = isValueChanged(gamesToRender);

    useEffect(() => {
        if (countColumnsChanged || gamesToRenderChanged) {
            let newAmountOfWinners = countColumns > 1
                ? Math.floor(gamesToRender.length / (countColumns - 1))
                : 0;
            if (newAmountOfWinners > maxAmountOfWinnersThumbnails) {
                newAmountOfWinners = maxAmountOfWinnersThumbnails;
            }
            setAmountOfWinnersThumbnails(newAmountOfWinners);
        }
    }, [countColumnsChanged, gamesToRenderChanged]);

    const countColumnsCallback = (thumbnailWidth) => {
        if (thumbnailWidth && containerGridRef && containerGridRef.current) {
            const containerWidth = containerGridRef.current.getBoundingClientRect().width;
            const countColumns = Math.floor(containerWidth / thumbnailWidth);
            setCountColumns(countColumns);
        }
    };

    return {
        countColumnsCallback,
        amountOfWinnersThumbnails
    };
};
